import emailConnectEndpoints from '@spotim/fed-resources/endpoints/email-connect';
import meEndpoints from '@spotim/fed-resources/endpoints/me';
import me from '@spotim/fed-resources/resources/me';
import moderationEndpoints from '@spotim/fed-resources/endpoints/moderation';
import socialConnect from '@spotim/fed-resources/endpoints/social-connect';
import {
  networkIdInjectorInterceptor,
  setNetworkIdInjectorValue,
  setSpotIdInjectorValue,
  spotIdInjectorInterceptor,
  tokenInjectorInterceptor
} from '@spotim/fed-common';
import { getNetwork, getToken } from 'app/scripts/services/app-state';
import statusInterceptor from './interceptors/status';
import { loginResponseInterceptor } from './interceptors/login-interceptor';

export async function syncToken(force = false) {
  var token = getToken();
  if (force || !token) {
    var network = getNetwork();
    try {
      let {
        body: { token }
      } = await me.fetchNetworkToken(network.id);
    } catch (error) {
      console.error(error);
    }
  }

  return token;
}

export function setupInterceptors(spotId, networkId) {
  try {
    if (spotId) {
      setSpotIdInjectorValue(spotId);
    }

    if (networkId) {
      setNetworkIdInjectorValue(networkId);
    }
    [
      socialConnect.toggleDisqusClaim,
      emailConnectEndpoints.multiEmailLogin,
      meEndpoints.loginRegistered,
      meEndpoints.login,
      meEndpoints.logout,
      meEndpoints.getMyMultiSpots,
      meEndpoints.getRoles,
      moderationEndpoints.twoWayVerification,
      moderationEndpoints.verifyCode
    ].forEach(endpoint => {
      endpoint.extendOptions({
        requestInterceptors: [
          tokenInjectorInterceptor.createRequestInterceptor(async () => await syncToken(false)),
          spotIdInjectorInterceptor.createRequestInterceptor(),
          networkIdInjectorInterceptor.createRequestInterceptor()
        ],
        responseInterceptors: [statusInterceptor.response, loginResponseInterceptor()]
      });
    });

    moderationEndpoints.setSuperOwner.extendOptions({
      requestInterceptors: [
        tokenInjectorInterceptor.createRequestInterceptor(async () => await syncToken(false)),
        spotIdInjectorInterceptor.createRequestInterceptor()
      ],
      responseInterceptors: [statusInterceptor.response, loginResponseInterceptor()]
    });
  } catch (e) {
    console.log('ERROR', e);
  }
}
